import { store } from "../store/index";

import { allConcept, getConcept, putConcept } from "../store/actions/ConceptActions";

/**
 * List account links
 */

export const getConceptByUuid = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getConcept(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const modifyConcept = async (param, data) => {
  const result = await store.dispatch(putConcept(param, data));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const getAllConcepts = async (param) => {
  const result = await store.dispatch(allConcept(param));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};
